<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :class="eventType === 'view' ? 'h550_dialog abow_dialog' : 'h660_dialog abow_dialog'"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="名称"
                    prop="name"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.name"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="级别"
                    :required="eventType!=='view'"
                  >
                    <el-radio-group
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.level"
                    >
                      <el-radio
                        :label="1"
                      >
                        一级
                      </el-radio>
                      <el-radio
                        :label="2"
                      >
                        二级
                      </el-radio>
                    </el-radio-group>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.levelStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogAddEditViewForm.level > 1"
                  :span="6"
                >
                  <el-form-item
                    label="上级中心"
                    prop="parentId"
                  >
                    <el-select
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.parentId"
                      filterable
                      clearable
                      placeholder="请选择上级中心"
                      style="width:100%"
                      @change="changeCenterFun"
                    >
                      <el-option
                        v-for="item in centerOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.parentName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              人员信息
            </h3>
            <div class="modal-row-box">
              <el-row
                v-if="eventType !== 'view'"
                :gutter="10"
              >
                <el-col :span="5">
                  <div class="search-box">
                    <el-input
                      v-model="userFilterText"
                      placeholder="查询用户"
                    />
                  </div>
                  <div class="left left-list-box">
                    <ul>
                      <li
                        v-for="(item,index) in userData"
                        :key="item.index"
                        :class="{'active':index==userCurrent}"
                        @dblclick="addToSetList(item, index)"
                        @click="userCheckedFun(item, index)"
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </el-col>

                <el-col :span="2">
                  <div class="transfer-button">
                    <el-button
                      type="success"
                      plain
                      @click="addSetUserFun"
                    >
                      添加
                    </el-button>
                    <el-button
                      type="warning"
                      plain
                      @click="deleteSetUserFun"
                    >
                      删除
                    </el-button>
                  </div>
                </el-col>

                <el-col :span="5">
                  <div class="right">
                    <ul class="right-list">
                      <li class="employee">
                        授权使用人员
                      </li>
                    </ul>
                    <div class="right-list-box">
                      <ul>
                        <draggable
                          :list="setUserData"
                          group="article"
                          class="dragArea"
                        >
                          <div
                            v-for="(element, index) in setUserData"
                            :key="index"
                            class="list-complete-item"
                            :class="{'active':index==setUserCurrent}"
                            @dblclick="deleteToSetList(element, index)"
                            @click="flowCheckedFun(element, index)"
                          >
                            <li class="employee">
                              {{ element.name }}
                            </li>
                          </div>
                        </draggable>
                      </ul>
                    </div>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="search-box">
                    <el-input
                      v-model="userManageFilterText"
                      placeholder="查询用户"
                    />
                  </div>
                  <div class="left left-list-box">
                    <ul>
                      <li
                        v-for="(item,index) in userManageData"
                        :key="item.index"
                        :class="{'active':index==userManageCurrent}"
                        @dblclick="addToSetManageList(item, index)"
                        @click="userManageCheckedFun(item, index)"
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </el-col>

                <el-col :span="2">
                  <div class="transfer-button">
                    <el-button
                      type="success"
                      plain
                      @click="addSetUserManageFun"
                    >
                      添加
                    </el-button>
                    <el-button
                      type="warning"
                      plain
                      @click="deleteSetUserManageFun"
                    >
                      删除
                    </el-button>
                  </div>
                </el-col>

                <el-col :span="5">
                  <div class="right">
                    <ul class="right-list">
                      <li class="employee">
                        授权管理人员
                      </li>
                    </ul>
                    <div class="right-list-box">
                      <ul>
                        <draggable
                          :list="setUserManageData"
                          group="article"
                          class="dragArea"
                        >
                          <div
                            v-for="(element, index) in setUserManageData"
                            :key="index"
                            class="list-complete-item"
                            :class="{'active':index==setUserManageCurrent}"
                            @dblclick="deleteToSetManageList(element, index)"
                            @click="flowManageCheckedFun(element, index)"
                          >
                            <li class="employee">
                              {{ element.name }}
                            </li>
                          </div>
                        </draggable>
                      </ul>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row
                v-else
                :gutter="10"
              >
                <el-col :span="24">
                  <el-form-item>
                    <el-input
                      v-model="dialogAddEditViewForm.authorizedUserNames"
                      type="textarea"
                      style="margin-top:10px;"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { loadUserSelectDataByUserTypeApi } from '@/api/user'
import { initExpenseCenterApi, saveOrUpdateExpenseCenterApi, getExpenseCenterListApi } from '@/api/expenseCenter'
export default {
  components: { draggable },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        parentId: [{ required: true, message: '请选择上级中心', trigger: 'change' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      centerOptions: [],
      userFilterText: '', // 职员集合过滤文字
      userData: [], // 职员数据源
      constUserData: [],
      userChecked: null,
      userCurrent: -1,
      setUserData: [],
      setUserChecked: null,
      setUserCurrent: -1,
      userManageFilterText: '', // 职员集合过滤文字
      userManageData: [], // 职员数据源
      constUserManageData: [],
      userManageChecked: null,
      userManageCurrent: -1,
      setUserManageData: [],
      setUserManageChecked: null,
      setUserManageCurrent: -1
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.centerOptions = []
        this.userFilterText = ''
        this.constUserData = []
        this.userChecked = null
        this.userCurrent = -1
        this.setUserData = []
        this.setUserChecked = null
        this.setUserCurrent = -1
        this.userManageFilterText = ''
        this.constUserManageData = []
        this.userManageChecked = null
        this.userManageCurrent = -1
        this.setUserManageData = []
        this.setUserManageChecked = null
        this.setUserManageCurrent = -1
        this.dialogAddEditViewForm = {
          name: '',
          level: 1,
          levelStr: '',
          parentId: '',
          parentName: '',
          authorizedUserIds: '',
          authorizedUserNames: '',
          manageUserIds: '',
          manageUserNames: '',
          remark: ''
        }
        if (this.eventType !== 'view') {
          this.initCenterSelectData()
          this.getUserData()
        }
        if (this.eventType !== 'add') {
          this.initPageData()
        }
      }
    },
    userFilterText (val) {
      this.userData = this.constUserData.filter(list => {
        return list.name.indexOf(val) !== -1
      })
    },
    userManageFilterText (val) {
      this.userManageData = this.constUserManageData.filter(list => {
        return list.name.indexOf(val) !== -1
      })
    }
  },
  methods: {
    // 加载数据
    initPageData () {
      initExpenseCenterApi({ id: this.dataId }).then(res => {
        const { data } = res
        for (let key in this.dialogAddEditViewForm) {
          this.dialogAddEditViewForm[key] = data[key]
        }
        if(data.parentId === 0){
          this.dialogAddEditViewForm.parentId = ''
        }
        this.dialogAddEditViewForm.id = data.id
        let manageNameArray = data.authorizedUserNames.split(',')
        data.authorizedUserIds.split(',').forEach((item, index) => {
          this.setUserData.push({ id: Number(item), name: manageNameArray[index] })
        })
        let manageArray = data.manageUserNames.split(',')
        data.manageUserIds.split(',').forEach((item, index) => {
          this.setUserManageData.push({ id: Number(item), name: manageArray[index] })
        })
        this.loading = false
      })
    },
    // 初始中心下拉数据
    initCenterSelectData () {
      let params = {
        parentId: 0
      }
      if(this.eventType !== 'add'){
        params.notId = this.dataId
      }
      getExpenseCenterListApi(params).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.centerOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择中心回调
    changeCenterFun (val) {
      let selectItem = {}
      selectItem = this.centerOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.centerName = selectItem ? selectItem.label : ''
    },
    // 获取职员清单
    getUserData () {
      loadUserSelectDataByUserTypeApi().then(response => {
        const { data } = response
        this.userData = data
        this.constUserData = data
        this.userChecked = null
        this.userCurrent = -1
        this.userManageData = data
        this.constUserManageData = data
        this.userManageChecked = null
        this.userManageCurrent = -1
        if (this.eventType === 'add') {
          this.loading = false
        }
      })
    },
    userCheckedFun (item, index) {
      this.userCurrent = index
      this.userChecked = item
    },
    flowCheckedFun (item, index) {
      this.setUserCurrent = index
      this.setUserChecked = item
    },
    addSetUserFun () {
      if (!this.userChecked) {
        this.$message.error('请选择要添加的用户')
        return
      }
      let hasItem = false
      this.setUserData.forEach(item => {
        if (item.id === this.userChecked.id) {
          hasItem = true
        }
      })
      if (!hasItem) {
        this.setUserData.push(this.userChecked)
      }
    },
    deleteSetUserFun () {
      if (!this.setUserChecked) {
        this.$message.error('请选择要删除的用户')
        return
      }
      let index = this.setUserData.indexOf(this.setUserChecked)
      if (index >= 0) {
        this.setUserCurrent = -1
        this.setUserData.splice(index, 1)
      }
    },
    addToSetList (item, index) {
      this.userCheckedFun(item, index)
      this.addSetUserFun()
    },
    deleteToSetList (item, index) {
      this.flowCheckedFun(item, index)
      this.deleteSetUserFun()
    },
    userManageCheckedFun (item, index) {
      this.userManageCurrent = index
      this.userManageChecked = item
    },
    flowManageCheckedFun (item, index) {
      this.setUserManageCurrent = index
      this.setUserManageChecked = item
    },
    addSetUserManageFun () {
      if (!this.userManageChecked) {
        this.$message.error('请选择要添加的用户')
        return
      }
      let hasItem = false
      this.setUserManageData.forEach(item => {
        if (item.id === this.userManageChecked.id) {
          hasItem = true
        }
      })
      if (!hasItem) {
        this.setUserManageData.push(this.userManageChecked)
      }
    },
    deleteSetUserManageFun () {
      if (!this.setUserManageChecked) {
        this.$message.error('请选择要删除的用户')
        return
      }
      let index = this.setUserManageData.indexOf(this.setUserManageChecked)
      if (index >= 0) {
        this.setUserManageCurrent = -1
        this.setUserManageData.splice(index, 1)
      }
    },
    addToSetManageList (item, index) {
      this.userManageCheckedFun(item, index)
      this.addSetUserManageFun()
    },
    deleteToSetManageList (item, index) {
      this.flowManageCheckedFun(item, index)
      this.deleteSetUserManageFun()
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          if (this.setUserData.length < 1) {
            this.$message.error('请选择授权人员')
            return false
          } else {
            let authorizedUserIds = ''
            let authorizedUserNames = ''
            this.setUserData.forEach(item => {
              authorizedUserIds += ',' + item.id
              authorizedUserNames += ',' + item.name
            })
            authorizedUserIds = authorizedUserIds.substring(1)
            authorizedUserNames = authorizedUserNames.substring(1)
            this.dialogAddEditViewForm.authorizedUserIds = authorizedUserIds
            this.dialogAddEditViewForm.authorizedUserNames = authorizedUserNames
          }
          if (this.setUserManageData.length < 1) {
            this.$message.error('请选择管理人员')
            return false
          } else {
            let manageUserIds = ''
            let manageUserNames = ''
            this.setUserManageData.forEach(item => {
              manageUserIds += ',' + item.id
              manageUserNames += ',' + item.name
            })
            manageUserIds = manageUserIds.substring(1)
            manageUserNames = manageUserNames.substring(1)
            this.dialogAddEditViewForm.manageUserIds = manageUserIds
            this.dialogAddEditViewForm.manageUserNames = manageUserNames
          }
          if(this.dialogAddEditViewForm.level > 1 && (this.dialogAddEditViewForm.parentId === 0 || this.dialogAddEditViewForm.parentId === '')){
            this.$message.error('请选择上级成本中心')
            return false
          }
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '成本中心', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              if(this.dialogAddEditViewForm.level === 1){
                this.dialogAddEditViewForm.parentId = 0
              }
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate () {
      saveOrUpdateExpenseCenterApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
.search-box {
  width: 100%;
  margin-bottom: 10px;
  margin-top: 10px;
}
.left {
  width: 100%;
  height: 250px;
  border: 1px solid #e6ebf5;
  float: left;
  background: #fff;
  box-sizing: border-box;
  margin-bottom: 10px;

  ul,
  li {
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 12px;
    line-height: 20px;
  }
}
.right {
  width: 100%;
  height: 250px;
  border: 1px solid #e6ebf5;
  float: left;
  background: #fff;
  box-sizing: border-box;
  margin-top: 48px;
  margin-bottom: 10px;

  ul,
  li {
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 12px;
    line-height: 20px;
  }
}
.left {
  padding: 5px 0;
}
.left li {
  padding: 0 5px;
}
.left-list-box {
  overflow-x: hidden;
  overflow: auto;
}

.transfer-button {
  width: 70px;
  float: left;
  padding-top: 120px;
  text-align: center;
}
.transfer-button .el-button {
  margin: 10px 0;
  flex: 1;
}
.right {
  width: 100%;
}
.right-list,
.list-complete-item {
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  box-sizing: border-box;
  display: flex;
  overflow-x: hidden;
}
.right-list li,
.list-complete-item li {
  padding: 0 5px;
  margin: 0;
  line-height: 24px;
  border-bottom: 1px solid #e6ebf5;
  flex: 1;
}
li.order {
  flex: 0 1 60px;
  width: 60px;
  border-right: 1px solid #e6ebf5;
}
li.employee {
  border-right: 1px solid #e6ebf5;
  text-align: center;
}
.right-list > li {
  background: #efefef;
}
.li:hover {
  background: #b2e1ff;
}
.active {
  background: #7fceff;
}
.right-list-box {
  height: 224px;
  overflow-x: hidden;
  overflow: auto;
}
</style>
